import React from 'react';

import { withStyles } from '@material-ui/core/styles';
import Fab from '@material-ui/core/Fab';

import * as strings from '../helpers/strings';

const styles = {
  root: {position: "fixed", bottom: 30, right: 30, zIndex: 1}
}

const BRFab = ({ classes, children, ...rest }) => (
  <Fab {...rest} className={classes.root} color={strings.colorPrimary}>{children}</Fab>
)

export default withStyles(styles)(BRFab);